import { RIN } from '../types';
export default {
  type: RIN,
  service: 'etherscan.io',
  url: 'https://rinkeby.etherscan.io/api',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
